<template>
    <div class="mb-5">
        <div v-if="section">
            <div class="card">
                <div class="card-body">
                    <h4>{{ section.number }} {{ section.name }}</h4>
                    <hr>

                    <div class="form-group mb-0">
                        <label>Content</label>                        
                        <textarea class="form-control" rows="12" v-model="section.content" ref="contentArea" @blur="onContentLostFocus"></textarea>
                        <!-- <div class="row mt-1">
                            <div class="col">
                                <button class="btn btn-light btn-sm mr-1" style="border: 1px solid #ccc;" disabled>
                                    <span class="mdi mdi-message-text-outline" style="color: inherit;"></span> Add Standard Phrase
                                </button>
                                <button class="btn btn-light btn-sm mr-2" style="border: 1px solid #ccc;" disabled>
                                    <span class="mdi mdi-comment-search-outline" style="color: inherit;"></span> Search Standard Phrases
                                </button>
                            </div>
                        </div> -->
                    </div>
                </div>

                <div class="card-footer">
                    <div class="row">
                        <div class="col">
                            <button class="btn btn-primary mr-2" @click="showPhraseSearch()">
                                <span class="mdi mdi-comment-search-outline"></span> Standard Phrases
                            </button>
                        </div>
                        <div class="col">
                            <div class="float-right">
                                <div style="display: inline-block; font-size: 1.3em;">
                                    <span class="mdi mdi-information-outline mdi-24px text-success mr-1"></span>
                                    <span class="text-muted">Auto-save is ON</span>
                                </div>

                                <button class="btn btn-success ml-3" :disabled="!hasChangedContent || isUpdating">
                                    <span class="mdi mdi-loading mdi-spin" v-if="isUpdating"></span>
                                    <span class="mdi mdi-content-save-all-outline" v-if="!isUpdating"></span> Save Changes
                                </button>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Standard phrases modal -->
            <b-modal
                id="modal-standard-phrases"
                ok-only
                ok-title="Close"
                ok-variant="secondary"
                size="lg">

                <template #modal-header>
                    <h4><span class="mdi mdi-message-text-outline mr-2"></span> Standard Phrases</h4>
                </template>

                <b-card no-body style="box-shadow: none;">
                    <b-tabs pills card>
                        <!-- Section specific phrases -->
                        <b-tab :title="`Section ${section.number} Phrases`" active>
                            <b-card-text>
                                <div v-if="!didLoadSectionSpecificPhrases">
                                    <h5 class="text-center">
                                        <span class="mdi mdi-loading mdi-spin mr-2"></span>
                                        Loading Phrases for Section 
                                    </h5>
                                </div>

                                <div style="max-height: 400px; overflow-y: auto;">
                                    <div class="list-group phrase-results">
                                        <a href="#" 
                                           class="list-group-item list-group-item-action pb-3 pt-3" 
                                           v-for="phrase in sectionSpecificPhrases" 
                                           :key="phrase.phrase_id"
                                           @click="copyPhrase(phrase)">
                                            <h5 class="mb-2">
                                                {{ phrase.name || phrase.code }}
                                                <button class="btn btn-primary btn-sm ml-1" @click="copyPhrase(phrase)">
                                                    <span class="mdi mdi-content-copy"></span> Copy Phrase
                                                </button>
                                            </h5>                            
                                            
                                            {{ phrase.content }}
                                        </a>
                                    </div>
                                </div>
                            </b-card-text>
                        </b-tab>
                        <!-- /Section specific phrases -->

                        <!-- Search Phrases-->
                        <b-tab>
                            <template #title>
                                <span class="mdi mdi-magnify"></span> Search Phrase Library
                            </template>

                            <form @submit="onSubmitPhraseSearch">
                                <div class="form-group">
                                    <div class="input-group mb-3">
                                        <input 
                                        id="tbStandardPhraseSearch"
                                        type="text" 
                                        class="form-control" 
                                        v-model="phraseSearchTerm" 
                                        placeholder="Search Standard Phrases">  
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" type="button" @click="onSubmitPhraseSearch">
                                                <span class="mdi mdi-magnify"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            
                            <div v-if="isSearchingPhrases">
                                <h5 class="text-center">
                                    <span class="mdi mdi-loading mdi-spin mr-2"></span>Searching Phrase Library...
                                </h5>
                            </div>
                            
                            <div style="max-height: 400px; overflow-y: auto;"  v-if="didSearchPhrases && !isSearchingPhrases">
                                <h5>{{ phraseSearchResults.length }} Phrases found for '{{ phraseSearchTermWas  }}'</h5>
                                <div class="list-group phrase-results">
                                    <a href="#" 
                                       class="list-group-item list-group-item-action pb-3 pt-3" 
                                       v-for="phrase in phraseSearchResults" 
                                       :key="phrase.phrase_id"
                                        @click="copyPhrase(phrase)">
                                        <h5 class="mb-2">
                                            {{ phrase.name || phrase.code }}
                                            <button class="btn btn-primary btn-sm ml-1" @click="copyPhrase(phrase)">
                                                <span class="mdi mdi-content-copy"></span> Copy Phrase
                                            </button>
                                        </h5>                            
                                        
                                        {{ phrase.content }}
                                    </a>
                                </div>
                            </div>
                        </b-tab>
                        <!-- /Search Phrases-->
                    </b-tabs>
                </b-card>
            </b-modal>
            
            <SectionRepairs class="mt-3" :sectionNumber="sectionNumber" :repairsProp="section.repairs" />
            <SectionMedia class="mt-3" :sectionNumber="sectionNumber" />
        </div>
    </div>
</template>

<script>
    import ReportService from '../../services/reports/reportService'
    import SectionRepairs from './SectionRepairs'
    import SectionMedia from './SectionMedia'
    import axios from 'axios'

    export default {
        props: {
            sectionNumber: String,
            sectionProp: Object
        },
        components: {
            SectionRepairs,
            SectionMedia
        },
        data() {
            return {
                section: this.sectionProp,
                jobReference: this.$route.params.jobReference,
                isUpdating: false,
                hasChangedContent: false,

                /* Standard phrase search */
                phraseSearchTerm: '',
                phraseSearchTermWas: '',
                didSearchPhrases: false,
                isSearchingPhrases: false,
                phraseSearchResults: [],

                /* Section specific phrases */
                didLoadSectionSpecificPhrases: false,
                sectionSpecificPhrases: []
            }
        },
        mounted() {
            if (this.section.content && this.section.content.indexOf('<br>' > -1)) {
                let nlReplaced = this.section.content.replace(/<br>/g, '\n')
                this.section.content = nlReplaced
            }
        },
        watch: {
            'section.content': function(val) {
                this.hasChangedContent = true
            }
        },
        methods: {
            setIsUpdating(isUpdating) {
                this.isUpdating = isUpdating
            },
            setUnchanged() {
                console.log('updating is changed to false')
                this.hasChangedContent = false
            },
            onContentLostFocus() {
                if (this.hasChangedContent) {
                    this.$emit('contentchanged', this, this.section.number, this.section.content)
                }
            },
            async showPhraseSearch() {
                this.phraseSearchTerm = ''
                this.didSearchPhrases = false
                this.phraseSearchResults = []

                this.$bvModal.show('modal-standard-phrases')
                
                if (!this.didLoadSectionSpecificPhrases) {
                    let phrasesUrl = `/api/standardphrases/?category=${this.section.number}`
                    let response = await axios.get(phrasesUrl)

                    this.sectionSpecificPhrases = response.data
                    this.didLoadSectionSpecificPhrases = true
                }
            },
            async onSubmitPhraseSearch(evt) {
                evt.preventDefault()
                
                try {
                    this.isSearchingPhrases = true
                    this.phraseSearchResults = []

                    let searchUrl = `/api/standardphrases/?searchTerm=${this.phraseSearchTerm}`
                    let response = await axios.get(searchUrl)
    
                    this.phraseSearchResults = response.data
                    
                    this.phraseSearchTermWas = this.phraseSearchTerm
                    this.isSearchingPhrases = false
                    this.didSearchPhrases = true
                    
                } catch (err) {
                    console.error(err)
                    this.$bvToast.toast('Sorry, something went wrong while searching the Standard Phrase library', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                }
            },
            async copyPhrase(phrase) {
                try {
                    await navigator.clipboard.writeText(phrase.content);
                    this.$bvToast.toast(`Phrase '${phrase.name || phrase.code}' Copied to Clipboard`, {
                        title: 'Success',
                        variant: 'success',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                
                } catch (err) {
                    console.error('Failed to copy: ', err);
                    this.$bvToast.toast('Sorry, something went wrong while copying phrase to clipboard', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                }
            }
        }
    }
</script>

<style scoped>
    #modal-standard-phrases .list-group-item button {
        opacity: 0;
    }

    #modal-standard-phrases .list-group-item:hover {
        background: lightcyan;
    }

    #modal-standard-phrases .list-group-item:hover button {
        opacity: 1;
    }
</style>